var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Author.View", ["require", "exports", "Backbone", "sc_blog_post_author.tpl"], function (require, exports, Backbone_1, categoryTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostAuthorView = /** @class */ (function (_super) {
        __extends(PostAuthorView, _super);
        function PostAuthorView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = categoryTemplate;
            _this.model.on('change', function () {
                _this.render();
            });
            return _this;
        }
        PostAuthorView.prototype.getContext = function () {
            return {
                author: this.model.author,
                authorName: this.model.authorName,
                authorUrl: this.model.authorUrl,
            };
        };
        return PostAuthorView;
    }(Backbone_1.View));
    exports.PostAuthorView = PostAuthorView;
});
